import { CollateralInfo } from "./CollateralInfo";
import { SingleValue } from "../../PSY/SingleValue";
import { twMerge } from "tailwind-merge"
import { CRITICAL_COLLATERAL_RATIO, Decimal, MINIMUM_COLLATERAL_RATIO, Percent, Trove, UserTrove } from '@liquity/lib-base'
import { COIN } from "src/strings";
import { Link } from "react-router-dom";
import { Button } from "src/components/PSY/Button"
import { CollateralLexicon } from "src/lexicon"

type Props = {
  lexicon: CollateralLexicon
  assetAddress: string;
  userTrove: UserTrove;
  price: Decimal;
  total: Trove
}
export const ProductListRow: React.FC<Props> = ({ lexicon, assetAddress, userTrove, price, total }) => {
  const isRecoveryMode = total.collateralRatio(price).lt(CRITICAL_COLLATERAL_RATIO);
  const collateralRatio = userTrove.collateralRatio(price)

  const crStyle = isRecoveryMode
    ? collateralRatio?.lt(CRITICAL_COLLATERAL_RATIO)
      ? "text-color-danger"
      : ""
    : collateralRatio?.lt(MINIMUM_COLLATERAL_RATIO)
      ? "text-color-danger"
      : collateralRatio?.gte(MINIMUM_COLLATERAL_RATIO) && collateralRatio?.lt(CRITICAL_COLLATERAL_RATIO)
        ? "text-color-warning"
        : ""
  const collateralRatioPct = new Percent(collateralRatio ?? { toString: () => "N/A" });

  return (
    <div className="flex flex-row justify-between items-center bg-component border-component p-5 w-full">
      <CollateralInfo
        name={lexicon.name}
        iconUrl={lexicon.iconUrl}
        unit={lexicon.term}
        className="min-w-[240px]"
      />
      <SingleValue
        label="Total Minted"
        value={total.debt.prettify(0)}
        unit={COIN}
      />
      <SingleValue
        label="Your collateral"
        value={userTrove.collateral.prettify(2)}
        unit={lexicon.term}
      />
      <SingleValue
        label="Your debt"
        value={userTrove.debt.prettify(0)}
        unit={COIN}
      />
      <SingleValue
        label="Ratio"
        value={collateralRatioPct.prettify()}
        className={twMerge("typo-lead-14 text-white", `${crStyle}`)}
      />
      <Link to={`/products/${assetAddress}`} >
        <Button className="ml-20">Manage</Button>
      </Link>
    </div>
  )
}